<template>
  <div class="header" :class="headerSelect == 2 ? 'green' : ''">
    <div class="headerBox">
      <div class="logoBox">
        <a :href="url"><img src="@/assets/images/logo/logo.png" alt=""/></a>
        <div class="headerSelectBox">
          <el-select
            v-model="headerSelect"
            placeholder="请选择"
            @change="changeHeaderSelect"
            size="small"
          >
            <el-option label="保险系统" value="1"> </el-option>
            <el-option label="财务系统" value="3"> </el-option>
            <el-option label="卡单系统" value="2"> </el-option>
          </el-select>
        </div>
        <div style="font-size: 18px;color:#fff;margin-left:20px;margin-top:3px;">
            系统所有方案的保障期限均以保单及批单为准
        </div>
      </div>
      <div class="rightBox">
        <div class="bellBox">
          <el-badge
            :is-dot="notice.length > 0"
            class="item"
            @click.native="changenoticedVisible"
          >
            <i class="el-icon-bell"></i>
          </el-badge>
        </div>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link" id="wateermark">
            {{ avatarName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="changePassword">
              修改密码
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible="amendVisible"
      :modal-append-to-body="false"
      @close="closeAmendBtn"
      width="450px"
    >
      <el-form
        :model="amendForm"
        :rules="rules2"
        :validate-on-rule-change="false"
        ref="amendForm"
        label-width="100px"
        class="amendForm"
        size="small"
      >
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="amendForm.password"
            placeholder="密码必须是数字和字母的组合,最少六位"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repeatPassword">
          <el-input
            v-model="amendForm.repeatPassword"
            placeholder="请输入内容"
            show-password
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="amendOk" size="small">
          确 定
        </el-button>
        <el-button @click="closeAmendBtn" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 公告弹窗 -->
    <el-dialog
      title="公告"
      :visible="noticedVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @close="noticeAmendBtn"
      width="450px"
    >
      <div class="noticeBox">
        <ul>
          <template v-if="notice.length > 0">
            <li v-for="(item, index) in notice" :key="index">
              <p class="noticeTit">{{ item.title }}</p>
              <p>{{ item.content }}</p>
            </li>
          </template>
          <li v-else>
            <p class="noticeNon">暂时没有公告~~~</p>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { changePassword } from "@/api/public";
import { getNotice } from "@/api/list";
import watermark from "@/utils/watermark.js";
import Cookies from "js-cookie";
import config from "@/config";
export default {
  name: "vHeader",
  data() {
    var password2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.amendForm.repeatPassword !== "") {
          this.$refs.amendForm.validateField("repeatPassword");
        }
        callback();
      }
    };
    var repPassWord2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.amendForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      headerSelect: this.$store.state.headerSelect, //系统选择
      url: this.$store.state.headerSelect == 1 ? "/" : "/#/hr",
      amendVisible: false, //修改账号弹窗
      amendForm: {
        id: "",
        password: "",
        repeatPassword: ""
      },
      rules2: {
        password: [
          { required: true, message: "密码不可为空", trigger: "blur" },
          { validator: password2, trigger: "blur" }
        ],
        repeatPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: repPassWord2, trigger: "blur" }
        ]
      },
      notice: [], //公告
      noticedVisible: false //公告弹窗
    };
  },
  mounted() {
    this.watermarkTit;
    // 获取公告
    this.getNotice();
  },
  methods: {
    // 退出
    logout() {
      this.$store.dispatch("logout");
    },
    // 修改密码
    changePassword() {
      this.amendForm.id = this.$store.getters.id;
      this.amendVisible = true;
    },
    // 修改密码弹窗关闭
    closeAmendBtn() {
      this.$nextTick(() => {
        this.$refs.amendForm.resetFields();
      });
      this.amendVisible = false;
    },
    // 修改密码弹窗确定
    amendOk() {
      this.$refs.amendForm.validate(valid => {
        if (valid) {
          let that = this;
          let loadind = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          changePassword(that.amendForm)
            .then(function(res) {
              console.log(res);
              loadind.close();
              if (res.code == 1) {
                that.$message.success("密码修改成功，请重新登陆");
                that.closeAmendBtn();
                that.$store.dispatch("logout");
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 选择系统
    changeHeaderSelect(e) {
      this.$store.state.headerSelect = e;
      if (e == 1) {
        this.$router.push({
          path: "/"
        });
      } 
      if(e == 2) {
        this.$router.push({
          path: "/hr"
        });
      }
      if(e == 3) {
        console.log(config.caiwuUrl)
        window.open(config.caiwuUrl + "/home.html#/?adminId=" + this.$store.getters.id);
      }
    },
    // 获取公告
    getNotice() {
      let that = this;
      var storageNotice = Cookies.get("storageNotice");
      console.log(storageNotice);
      getNotice()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.notice = res.data;
            if (!storageNotice) {
              if (res.data.length > 0) {
                that.noticedVisible = true;
              }
              Cookies.set("storageNotice", "true");
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 打开公告
    changenoticedVisible() {
      let that = this;
      getNotice()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.notice = res.data;
            that.noticedVisible = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 关闭公告
    noticeAmendBtn() {
      this.noticedVisible = false;
    }
  },
  computed: {
    avatarName() {
      return this.$store.getters.name;
    },
    watermarkTit() {
      return watermark.set(this.$store.getters.name);
    }
  },
  watch: {
    "$store.state.headerSelect": function(e) {
      this.headerSelect = e;
      if (e == 1) {
        this.url = "/";
      } else {
        this.url = "/#/hr";
      }
    }
  }
};
</script>
<style lang="scss">
.header {
  width: 100%;
  background: linear-gradient(96deg, #0067ca 0%, #00aaf1 100%);
  box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
  position: fixed;
  top: 0;
  z-index: 100;
  .headerBox {
    width: 100%;
    height: 54px;
    padding: 10px 24px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > .logoBox {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: normal;
      img {
        max-height: 100%;
      }
      .headerSelectBox {
        margin-left: 25px;
        width: 145px;
        input {
          background: transparent;
          color: #fff;
          font-size: 14px;
          border-color: #8ac9f4eb;
        }
      }
    }
    & > .rightBox {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .bellBox {
        margin-right: 50px;
        cursor: pointer;
        i {
          font-size: 24px;
          color: #fff;
        }
        sup {
          background: #f86837;
          border-radius: 9px;
          border: 0;
        }
      }
      .bellBox:hover {
        color: #666;
      }
      & > .el-dropdown {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }
}
// 人力资源
.green.header {
  background: #2ca063;
  .headerBox > .logoBox {
    .headerSelectBox input {
      border-color: #4bbc80;
    }
  }
}
</style>
<style lang="scss">
.noticeBox {
  margin-top: -30px;
  max-height: calc(100vh - 300px);
  overflow: auto;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      border-bottom: 1px dashed #ededed;
      p {
        margin: 0;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        margin: 10px 0;
      }
      p.noticeTit {
        text-align: center;
        margin-top: 15px;
      }
      p.noticeNon {
        text-align: center;
        font-size: 14px;
        color: #ccc;
      }
    }
  }
}
</style>
